import repository from '@/utils/repository';

export default {
    searchUserCustomerInfo: (data) => {
        return repository.post(`/move/postCommonUserCustomerInfo`, {
            ...data
        });
    }
};
